import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import {
  PANEL_ROW_DOT_PLOTS_BOXES_CONVERTER_TOKEN, PanelRowDotPlotsBoxesConverter
} from '../../panel-row-dot-plots-boxes/panel-row-dot-plots-boxes.component.converter'
import { FsComponentConverter } from 'fs-spartacus-common'
import {
  PANEL_ROW_DOT_PLOTS_BOX_CONVERTER_TOKEN, PanelRowDotPlotsBoxConverter
} from '../../panel-row-dot-plots-boxes/panel-row-dot-plots-box/panel-row-dot-plots-box.component.converter'
import {
  PANEL_ROW_HEADLINE_CONVERTER_TOKEN, PanelRowHeadlineConverter
} from '../../panel-row-headline/panel-row-headline.component.converter'
import { PANEL_ROW_IMAGE_CONVERTER_TOKEN, PanelRowImageConverter } from '../../panel-row-image/panel-row-image.component.converter'
import {
  PANEL_ROW_IMAGE_XL_CONVERTER_TOKEN, PanelRowImageXlConverter
} from '../../panel-row-image-xl/panel-row-image-xl.component.converter'
import {
  PANEL_ROW_PDF_TEASER_CONVERTER_TOKEN, PanelRowPdfTeaserConverter
} from '../../panel-row-pdf-teaser/panel-row-pdf-teaser.component.converter'
import {
  PANEL_ROW_PDF_TEASER_XL_CONVERTER_TOKEN, PanelRowPdfTeaserXlConverter
} from '../../panel-row-pdf-teaser-xl/panel-row-pdf-teaser-xl.component.converter'
import {
  PANEL_ROW_RELATED_CONTENT_CONVERTER_TOKEN, PanelRowRelatedContentConverter
} from '../../panel-row-related-content/panel-row-related-content.component.converter'
import {
  PANEL_ROW_RELATED_CONTENT_LINK_CONVERTER_TOKEN, PanelRowRelatedContentLinkConverter
} from '../../panel-row-related-content/panel-row-related-content-link/panel-row-related-content-link.component.converter'
import {
  PANEL_ROW_RELATED_HANDBOOK_ARTICLES_CONVERTER_TOKEN, PanelRowRelatedHandbookArticlesConverter
} from '../../panel-row-related-handbook-articles/panel-row-related-handbook-articles.component.converter'
import {
  PANEL_ROW_RELATED_HANDBOOK_ARTICLES_LINK_CONVERTER_TOKEN, PanelRowRelatedHandbookArticlesLinkConverter
} from '../../panel-row-related-handbook-articles/panel-row-related-handbook-articles-link/panel-row-related-handbook-articles-link.component.converter'
import {
  PANEL_ROW_RELATED_PDFS_CONVERTER_TOKEN, PanelRowRelatedPdfsConverter
} from '../../panel-row-related-pdfs/panel-row-related-pdfs.component.converter'
import {
  PANEL_ROW_RELATED_PDFS_LINK_CONVERTER_TOKEN, PanelRowRelatedPdfsLinkConverter
} from '../../panel-row-related-pdfs/panel-row-related-pdfs-link/panel-row-related-pdfs-link.component.converter'
import {
  PANEL_ROW_RELATED_PRODUCTS_CONVERTER_TOKEN, PanelRowRelatedProductsConverter
} from '../../panel-row-related-products/panel-row-related-products.component.converter'
import {
  PANEL_ROW_RELATED_PRODUCTS_LINK_CONVERTER_TOKEN, PanelRowRelatedProductsLinkConverter
} from '../../panel-row-related-products/panel-row-related-products-link/panel-row-related-products-link.component.converter'
import {
  PANEL_ROW_RELATED_TEXT_CONVERTER_TOKEN, PanelRowRelatedTextConverter
} from '../../panel-row-related-text/panel-row-related-text.component.converter'
import {
  PANEL_ROW_RELATED_VIDEOS_CONVERTER_TOKEN, PanelRowRelatedVideosConverter
} from '../../panel-row-related-videos/panel-row-related-videos.component.converter'
import {
  PANEL_ROW_RELATED_VIDEOS_LINK_CONVERTER_TOKEN, PanelRowRelatedVideosLinkConverter
} from '../../panel-row-related-videos/panel-row-related-videos-link/panel-row-related-videos-link.component.converter'
import { PANEL_ROW_TEXT_CONVERTER_TOKEN, PanelRowTextConverter } from '../../panel-row-text/panel-row-text.component.converter'
import { PANEL_ROW_VIDEO_CONVERTER_TOKEN, PanelRowVideoConverter } from '../../panel-row-video/panel-row-video.component.converter'
import {
  PANEL_ROW_VIDEO_IMAGE_XL_CONVERTER_TOKEN, PanelRowVideoImageXlConverter
} from '../../panel-row-video-image-xl/panel-row-video-image-xl.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        openPanelSubcomponentWrapperFeature: {
          module: () => import('./open-panel-subcomponent-wrapper.module').then((m) => m.OpenPanelSubcomponentWrapperModule),
        },
      }
    }),
    {
      provide: PANEL_ROW_DOT_PLOTS_BOXES_CONVERTER_TOKEN,
      useExisting: PanelRowDotPlotsBoxesConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_dot_plots_boxes: PANEL_ROW_DOT_PLOTS_BOXES_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_DOT_PLOTS_BOX_CONVERTER_TOKEN,
      useExisting: PanelRowDotPlotsBoxConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_dot_plots_box: PANEL_ROW_DOT_PLOTS_BOX_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_HEADLINE_CONVERTER_TOKEN,
      useClass: PanelRowHeadlineConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panelrowheadline: PANEL_ROW_HEADLINE_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_IMAGE_CONVERTER_TOKEN,
      useClass: PanelRowImageConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_image: PANEL_ROW_IMAGE_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_IMAGE_XL_CONVERTER_TOKEN,
      useClass: PanelRowImageXlConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panelrowimagexl: PANEL_ROW_IMAGE_XL_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_PDF_TEASER_CONVERTER_TOKEN,
      useClass: PanelRowPdfTeaserConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_pdf: PANEL_ROW_PDF_TEASER_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_PDF_TEASER_XL_CONVERTER_TOKEN,
      useClass: PanelRowPdfTeaserXlConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_pdf_teaser_xl: PANEL_ROW_PDF_TEASER_XL_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_RELATED_CONTENT_CONVERTER_TOKEN,
      useClass: PanelRowRelatedContentConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_related_content: PANEL_ROW_RELATED_CONTENT_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_RELATED_CONTENT_LINK_CONVERTER_TOKEN,
      useClass: PanelRowRelatedContentLinkConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_related_content_link: PANEL_ROW_RELATED_CONTENT_LINK_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_RELATED_HANDBOOK_ARTICLES_CONVERTER_TOKEN,
      useClass: PanelRowRelatedHandbookArticlesConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_related_handbook_articles: PANEL_ROW_RELATED_HANDBOOK_ARTICLES_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_RELATED_HANDBOOK_ARTICLES_LINK_CONVERTER_TOKEN,
      useClass: PanelRowRelatedHandbookArticlesLinkConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_related_handbook_article_link: PANEL_ROW_RELATED_HANDBOOK_ARTICLES_LINK_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_RELATED_PDFS_CONVERTER_TOKEN,
      useClass: PanelRowRelatedPdfsConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_related_pdfs: PANEL_ROW_RELATED_PDFS_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_RELATED_PDFS_LINK_CONVERTER_TOKEN,
      useClass: PanelRowRelatedPdfsLinkConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_related_pdf_link: PANEL_ROW_RELATED_PDFS_LINK_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_RELATED_PRODUCTS_CONVERTER_TOKEN,
      useClass: PanelRowRelatedProductsConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_related_products: PANEL_ROW_RELATED_PRODUCTS_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_RELATED_PRODUCTS_LINK_CONVERTER_TOKEN,
      useClass: PanelRowRelatedProductsLinkConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_related_products_link: PANEL_ROW_RELATED_PRODUCTS_LINK_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_RELATED_TEXT_CONVERTER_TOKEN,
      useClass: PanelRowRelatedTextConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_related_text: PANEL_ROW_RELATED_TEXT_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_RELATED_VIDEOS_CONVERTER_TOKEN,
      useClass: PanelRowRelatedVideosConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_related_videos: PANEL_ROW_RELATED_VIDEOS_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_RELATED_VIDEOS_LINK_CONVERTER_TOKEN,
      useClass: PanelRowRelatedVideosLinkConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_related_video_link: PANEL_ROW_RELATED_VIDEOS_LINK_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_TEXT_CONVERTER_TOKEN,
      useClass: PanelRowTextConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panelrowtext: PANEL_ROW_TEXT_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_VIDEO_CONVERTER_TOKEN,
      useClass: PanelRowVideoConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_video: PANEL_ROW_VIDEO_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: PANEL_ROW_VIDEO_IMAGE_XL_CONVERTER_TOKEN,
      useClass: PanelRowVideoImageXlConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        panel_row_video_image_xl: PANEL_ROW_VIDEO_IMAGE_XL_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class OpenPanelSubcomponentWrapperFeatureModule {}
